import React from 'react';
import { css } from '@emotion/react';
import { i18n_100_breathwork_practices } from '@yi/i18n/phrases/i18n_100_breathwork_practices';
import { i18n_15_docuseries_and_podcasts } from '@yi/i18n/phrases/i18n_15_docuseries_and_podcasts';
import { i18n_2_700_in_depth_articles } from '@yi/i18n/phrases/i18n_2_700_in_depth_articles';
import { i18n_300_courses_and_challenges__v2 } from '@yi/i18n/phrases/i18n_300_courses_and_challenges__v2';
import { i18n_3_000_yoga_classes } from '@yi/i18n/phrases/i18n_3_000_yoga_classes';
import { i18n_700_meditations } from '@yi/i18n/phrases/i18n_700_meditations';
import { i18n_membership_includes } from '@yi/i18n/phrases/i18n_membership_includes';

import { Bold } from '~/src/components/i18n';
import { useLocale } from '~/src/components/LocaleProvider';
import { breakpoints, fontWeight } from '~/src/styles';
import { paddingVariables, typography } from '~/src/styles/design-system';
import { resetStyles } from '~/src/styles/reset-styles-mixins';

import { commonStyles } from './common-styles';
import { StartFreeTrialButton } from './StartFreeTrialButton';

const styles = {
  heading: css(commonStyles.h1, {
    gridArea: 'title',
    color: 'var(--Dark-Text, #27292D)',
  }),
  body: css(commonStyles.containerMaxWidth, {
    margin: 'auto',
    display: 'grid',
    gridTemplateAreas: "'.' 'title' '.'  'list' '.' 'button' '.'",
    gridTemplateRows: `${paddingVariables.p56} auto ${paddingVariables.p24} auto ${paddingVariables.p56} auto ${paddingVariables.p56}`,
    [breakpoints.minTablet]: {
      gridTemplateRows: `${paddingVariables.p80} auto ${paddingVariables.p56} auto ${paddingVariables.p80} auto ${paddingVariables.p80}`,
    },
    [breakpoints.minDesktop]: {
      gridTemplateRows: `${paddingVariables.p120} auto ${paddingVariables.p80} auto ${paddingVariables.p120} auto ${paddingVariables.p120}`,
    },
  }),
  list: css(resetStyles.ul, commonStyles.contentPadding, {
    gridArea: 'list',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    rowGap: '24px',
    columnGap: '40px',
    [breakpoints.minDesktop]: {
      gridTemplateColumns: '1fr 1fr 1fr',
      rowGap: '80px',
    },
  }),
  contentType: css(typography.bodyText, {
    fontWeight: fontWeight.semiBold,
    color: 'var(--Grey-Text, #585858)',
    display: 'flex',
    flexDirection: 'column',
    b: {
      fontWeight: fontWeight.bold,
    },
    [breakpoints.minTablet]: typography.heading1,
    [breakpoints.minTablet]: {
      color: 'var(--Grey-Text, #585858)',
      fontWeight: fontWeight.medium,
      fontSize: '22px',
      lineHeight: '40px',
    },
    [breakpoints.minDesktop]: [
      typography.subHeading1,
      {
        fontSize: '24px',
        lineHeight: '40px',
        color: 'var(--Grey-Text, #585858)',
      },
    ],
    '& b': {
      fontSize: '26px',
      lineHeight: '36px',
      [breakpoints.minTablet]: [
        typography.heading1,
        {
          color: 'var(--Primary, #EF743C)',
        },
      ],
      [breakpoints.minDesktop]: {
        fontSize: '45px',
        fontWeight: fontWeight.bold,
        lineHeight: '60px',
        letterSpacing: '2.25px',
      },
    },
  }),
  startFreeTrialButton: css(commonStyles.contentPadding, {
    gridArea: 'button',
  }),
};

export const MembershipIncludes: React.FC = () => {
  const { locale } = useLocale();

  return (
    <section css={styles.body}>
      <h1 css={styles.heading}>{i18n_membership_includes(locale)}</h1>
      <ul css={styles.list}>
        <li css={styles.contentType}>{i18n_3_000_yoga_classes(locale, { transformFn: Bold })}</li>
        <li css={styles.contentType}>{i18n_700_meditations(locale, { transformFn: Bold })}</li>
        <li css={styles.contentType}>
          {i18n_100_breathwork_practices(locale, { transformFn: Bold })}
        </li>
        <li css={styles.contentType}>
          {i18n_2_700_in_depth_articles(locale, { transformFn: Bold })}
        </li>
        <li css={styles.contentType}>
          {i18n_300_courses_and_challenges__v2(locale, { transformFn: Bold })}
        </li>
        <li css={styles.contentType}>
          {i18n_15_docuseries_and_podcasts(locale, { transformFn: Bold })}
        </li>
      </ul>
      <StartFreeTrialButton css={styles.startFreeTrialButton} />
    </section>
  );
};
